import {FC, useEffect, useState} from 'react'
import {getCustomerAddresses} from 'app/features/customers/redux/customerSlice'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from 'setup'
import OrderModal from 'app/features/orders/componentsv1/view/orderModal/OrderModal'
import {KTSVG} from '_metronic/helpers'
import AddressList from './AddressList'

type Props = {
  onClose: any
  customerId: any
  title?: any
  selectedAddress?: any
  onChangeAddress: (address: any) => void
}

const CustomerAddressDialog: FC<Props> = ({
  onClose,
  customerId,
  selectedAddress,
  onChangeAddress,
}) => {
  const dispatch = useDispatch()
  const addressList = useSelector<RootState, any[]>(({orders}) => orders.customer.customerAddress)
  const isFetching = useSelector<RootState, boolean>(({orders}) => orders.customer.isFetching)
  const [showAddAddress, setShowAddAddress] = useState(false)
  const [addressId, setAddressId] = useState('')


  useEffect(() => {
    if (customerId) {
      dispatch(getCustomerAddresses(customerId))
    }
  }, [dispatch, customerId])

  const handleAddAddress = () => {
    setShowAddAddress(true)
  }
  const handleCloseAddress = (id?: string) => {
    if (addressList.length === 0 && id) {
      return
    }
    if (showAddAddress) {
      setShowAddAddress(false)
      setAddressId('')
    } else {
      onClose()
    }
  }

  const handleSetAddress = (show: boolean, id: string) => {
    setShowAddAddress(show)
    setAddressId(id)
  }

  const handleSelectAddress = async (address: any) => {
    onChangeAddress(address)
  }

  return (
    <OrderModal
      onClose={handleCloseAddress}
      title={showAddAddress && !addressId ? 'Add New Address ' : 'Change the Shipping Address'}
      btnText='Confirm'
      icon={'location'}
      hideFooter
    >
      <AddressList
        addressList={addressList}
        isFetching={isFetching}
        onClose={handleCloseAddress}
        customerId={customerId}
        onShowAddress={handleSetAddress}
        onChangeAddress={handleSelectAddress}
        checkedAddress={selectedAddress}
        address={{
          id: addressId,
          dialog: showAddAddress,
        }}
      >
        <div className='pb-7'>
          <button
            type='button'
            title='Add New Address'
            onClick={handleAddAddress}
            className='btn explore-btn-outline text-primary-active w-100'
          >
            <KTSVG
              path='/media/icons/duotune/arrows/arr075.svg'
              className='svg-icon-3 svg-icon-primary-active'
            />
            Add New Address
          </button>
        </div>
      </AddressList>
    </OrderModal>
  )
}

export default CustomerAddressDialog
